import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import FormDropdown from '../../../components/FormDropdown';
import { QUESTION_LIST, SCHEDULE_LIST } from "../endpoints";
import fp from "lodash/fp";
import CustomModal from "../CustomModal";
import EditModal from "../../../components/EditModal";
import EditModalOrder from "../../../components/EditModalOrder";
import ImageZoom from "react-medium-image-zoom";
import { trimStart } from "lodash";

const tipe_soal = [

    { key: "single", value: "Single Option" },

    { key: "essay", value: "Essay" }
];

class Lists extends React.Component {
    constructor() {
        super();
        this.state = {
            dataSoal: [],
            detailSoal: [],
            dataQuestion: [],
            dataDetailExam: {},
            jumlahPilihanGanda: 0,
            exam_cat_id: 0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isDetailExamLoading: false,
            isModalShow: false,
            isModalEditShow: false,
            modalEditOrderShow: false,
            isDisabled: true,
            isEdit: true,
            question_id: "",
            orderId: "",
            score: 0,
            question_type : "",
            checkedState: [],
            checkAll: false
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModalEdit = this.toggleModalEdit.bind(this);
        this.toggleModalEditOrder = this.toggleModalEditOrder.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);

    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    loadData() {
        this.setState({ isLoading: true });

        axios({
            method: "post",
            url: '/ujian/soal/list',
            data: qs.stringify({question_type:this.state.question_type, exam_id: this.props.match.params.exam_id, user_id: localStorage.SISMART_USER_ID, page: this.state.currentPage + 1 })
        })
            .then(response => {
                const result = response.data;
                if (result.success === true) {
                    this.setState({
                        checkedState:new Array(result.data.soal.length).fill(false)
                    })
                    this.setState({
                        dataQuestion: result.data.soal,
                        // pageCount: result.data.soal.last_page,
                        dataDetailExam: result.data.exam,
                        isLoading: false
                    });
                    var jumlah_soal = result.data.soal.length

                    this.setState({
                        jumlah_soal: jumlah_soal
                    })


                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataDetail(e) {

        this.setState({ isLoading: true });
            axios({
                method: "post",
                url: '/ujian/soal/detail',
                data: qs.stringify({ question_id: e, exam_id: this.props.match.params.exam_id})
            })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({
                        detailSoal: result.data,
                        score: result.data.score,
                        question_id: result.data.question_id,
                        isLoading: false
                    });

                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }

            })

            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    toggleModal(e) {
        this.setState({
            modalShow: !this.state.modalShow,
            question_id : e
        });
    }

    toggleModalEdit(e) {
        this.setState({
            modalEditShow: !this.state.modalEditShow,
            question_id : e
        });

        if (!this.state.modalEditShow) {
            this.loadDataDetail(e);
        }
    }

    toggleModalEditOrder(e, order) {
        this.setState({
            modalEditOrderShow: !this.state.modalEditOrderShow,
            question_id : e,
            orderId : order
        });
    }

    handleHapusButton = async () => {
        let promiseDelete = []
        this.setState({ isButtonLoading: true });
        this.state.checkedState.forEach((statusCheckbox, i) => {
            if (statusCheckbox) {
                promiseDelete.push(this.handleApiDelete(this.state.dataQuestion[i].question_id))
            }
        });
        if (promiseDelete.length === 0) {
            Alert.error("Pilih Soal Yang Ingin Di Delete");
        } else {
            setTimeout( async () => {
                await Promise.all(promiseDelete)
                .then((data) => {
                    console.log(data)
                    Alert.success("Success delete soal");
                    this.setState({ modalShow: false });
                    this.setState({ isButtonLoading: false });
                    setTimeout(() => {
                        window.location.reload()
                    }, 500);
                }).catch((error)=>{
                    console.log(error);
                    this.setState({ modalShow: false });
                    this.setState({ isButtonLoading: false });
                    Alert.error("Gagal terhubung ke server!");
                    setTimeout(() => {
                        window.location.reload()
                    }, 500);
                })
            }, 500);
        }

    }

    handleApiDelete(a){
        const url = 'ujian/soal/del'

        let newState = {
            user_id:localStorage.SISMART_USER_ID,
            question_id:a,
            exam_id:this.props.match.params.exam_id
        };

        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

        .then(response => {
            const result = response.data;
            if (result.success) {
                return Promise.resolve(result)
            } else {
                if (Array.isArray(result.message)) {
                    result.message.map(item => {
                        // Alert.error(item);

                        return Promise.resolve(result)
                    });
                } else {
                    return Promise.resolve(result)
                }
            }
        })
        .catch(error => {
            console.log(error);
            Alert.error("Gagal terhubung ke server!");
        });
    }

    handleEdit(){
        this.setState({
            isEdit : !this.state.isEdit,
            isDisabled : !this.state.isDisabled
        });
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.question_type !== this.state.question_type ) {
            this.loadData()
        }

    }

    render() {
        const handleOnChange = (position) => {
            const updatedCheckedState = this.state.checkedState.map((item, index) =>
                index === position ? !item : item
            );
            let trCheck = 0
            updatedCheckedState.forEach(checkState => {
                if (checkState === true) {
                    trCheck = 1
                }
            });

            if (trCheck === 0) {
                this.setState({checkAll:false})
            } else {
                this.setState({checkAll:true})
            }
            this.setState({checkedState:updatedCheckedState});

        };

        const handleOnCheckAll = () =>{
            this.setState({
                checkedState:new Array(this.state.dataQuestion.length).fill(!this.state.checkAll)
            })
            this.setState({checkAll:!this.state.checkAll})
        }

        return (
            <div>
                <CustomModal
                    modalHeaderText="Hapus"
                    modalBodyText="Anda yakin ingin menghapus?"
                    modalSubmitText="Hapus"
                    handleSubmit={() => this.handleHapusButton()}
                    toggleModal={this.toggleModal}
                    isShow={this.state.modalShow}
                />
                <EditModal
                    modalHeaderText="Add Soal"
                    modalBodyText = "Anda yakin ingin menghapus?"
                    modalSubmitText="Add Soal"
                    detailSoal = {this.state.detailSoal}
                    score = {this.state.score}
                    detailExam = {this.props.match.params.exam_id}
                    toggleModalEdit={this.toggleModalEdit}
                    isShow={this.state.modalEditShow}
                />
                <EditModalOrder
                    modalHeaderText="Pindah Soal"
                    modalBodyText = "Anda yakin ingin merubah urutan soal?"
                    modalSubmitText="Pindah Soal"
                    orderId = {this.state.orderId}
                    quesId = {this.state.question_id}
                    examId = {this.props.match.params.exam_id}
                    toggleModalEditOrder={this.toggleModalEditOrder}
                    isShow={this.state.modalEditOrderShow}
                />
                <div className="card">
                    <div className="card-header">
                        <div style={{ marginTop: "10px", display: "inline-block" }}>
                            Data Pertanyaan
                        </div>
                        <NavLink
                            to={`${this.props.match.url}/export`}
                            className="btn btn-secondary pull-right"
                            style={{ marginTop: "2px", marginLeft:'5px' }}
                        >
                            <i className="fa fa-file-pdf-o"></i>{" "}Export Soal
                        </NavLink>
                        <NavLink
                            to={`${this.props.match.url}/add`}
                            className="btn btn-primary pull-right"
                            style={{ marginTop: "2px" }}
                        >
                            Tambah Pertanyaan
                        </NavLink>
                        <NavLink
                            to={`/exam/schedule`}
                            className="btn btn-secondary pull-right"
                            style={{ marginTop: "2px", marginRight: "5px" }}
                        >
                            <i className="fa fa-chevron-left" /> Kembali ke list
                        </NavLink>
                    </div>

                    <div Class="card-body">
                        <table className="table table-striped table-bordered animated fadeIn">
                            <tr>
                                <td>ID Soal </td>
                                <td>{this.state.dataDetailExam.exam_id}</td>
                            </tr>
                            <tr>
                                <td>Judul </td>
                                <td>{this.state.dataDetailExam.exam_title}</td>
                            </tr>
                            <tr>
                                <td>Deskripsi </td>
                                <td>{this.state.dataDetailExam.exam_desc}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Mulai </td>
                                <td>{this.state.dataDetailExam.exam_start_date}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Selesai </td>
                                <td>{this.state.dataDetailExam.exam_end_date}</td>
                            </tr>
                            <tr>
                                <td>Durasi </td>
                                <td>{this.state.dataDetailExam.exam_time_limit}</td>
                            </tr>
                            <tr>
                                <td>Soal </td>
                                <td>{this.state.jumlah_soal}</td>
                            </tr>
                            <tr>
                                <td>Total Nilai </td>
                                <td>
                                    {this.state.dataDetailExam.scoreMax}
                                    <br/>
                                    <span className="text-danger" style={{fontSize:'12px'}}>*Nilai berdasarkan input saat tambah soal</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <div className="form-group row">
                                <div className="col-md-3">
                                    <FormDropdown
                                        items = {tipe_soal}
                                        onChange = {this.handleChange}
                                        value={this.state.question_type.toString()}
                                        placeholder={"Pilih Type"}
                                        name="question_type"
                                    />
                                </div>
                                <div className="col-md-9">
                                    <button
                                    type="button"
                                    className="btn btn-danger btn-sm  float-right"
                                    onClick={() => {
                                        this.toggleModal();
                                    }}
                                    >
                                    Hapus
                                    </button>
                                </div>
                            </div>
                        </div>
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : this.state.dataQuestion.length === 0 ? (
                            "Data Kosong..."
                        ) : (
                            <div>
                                <div className="card-block">
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                            <tr>
                                                <th width={10}>
                                                    <input
                                                        type="checkbox"
                                                        id="checkBoxAll"
                                                        checked={this.state.checkAll}
                                                        onChange={() => handleOnCheckAll()}
                                                    />
                                                </th>
                                                <th width={25}>No</th>
                                                <th>Pertanyaan</th>
                                                {/*<th width={25}>Order</th>*/}
                                                <th width={200}>Opsi</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataQuestion.map((itemQues, i) => {
                                                    return (
                                                        <tr key={itemQues.question_id} className={this.state.checkedState[i]? "bg-color-remove":""}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox${i}`}
                                                                    checked={this.state.checkedState[i]}
                                                                    onChange={() => handleOnChange(i)}
                                                                />
                                                            </td>
                                                            <td>{i + 1}</td>
                                                            <td>
                                                                <span className="badge badge-danger">{itemQues.question_type}</span><br />
                                                                <p><div dangerouslySetInnerHTML={{__html: itemQues.question_text}}/></p>
                                                                {
                                                                    itemQues.question_pict ? (
                                                                        <div>
                                                                            <ImageZoom
                                                                                image={{
                                                                                    src: "data:" + itemQues.question_type_pict + ";base64," + itemQues.question_pict,
                                                                                    className: 'img',
                                                                                    style: {width: '20em'}
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : ""
                                                                }

                                                                <p style={{marginBottom: 5}}/>
                                                                {itemQues.question_type == 'essay' ? (
                                                                    "Essay..."
                                                                ) : (
                                                                    itemQues.question_type == 'match' ? (
                                                                        itemQues.opsi.length > '0' ? itemQues.opsi.map((itemx, i) => (
                                                                                <div
                                                                                    className="checkbox"
                                                                                    key={`pilihanGanda-${itemx.question_id}-${i}`}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        value="option1"
                                                                                        checked={itemx.score.length > 0}
                                                                                        style={{marginRight: 5}}
                                                                                        disabled
                                                                                    />
                                                                                    {itemx.option_text + " "}
                                                                                    <i className="fa fa-arrows-h fa-lg mt-4"></i>
                                                                                    {" " + itemx.option_match_text}
                                                                                </div>
                                                                            )) :
                                                                            <div
                                                                                className="alert alert-danger"
                                                                                role="alert">
                                                                                No Option!! Question Not valid
                                                                            </div>
                                                                    ) : (
                                                                        itemQues.opsi.length > '0' ? itemQues.opsi.map((itemx, i) => (
                                                                                <div className="radio"
                                                                                     key={`pilihanGanda-${itemx.question_id}-${i}`}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        value="option1"
                                                                                        checked={itemx.score.length > 0}
                                                                                        style={{marginRight: 5}}
                                                                                        disabled
                                                                                    />
                                                                                    <a>{itemx.option_text}</a>

                                                                                    {
                                                                                        itemx.option_pict ? (
                                                                                            <ImageZoom
                                                                                                image={{
                                                                                                    src: "data:" + itemx.type_pict + ";base64," + itemx.option_pict,
                                                                                                    className: 'img',
                                                                                                    style: {width: '10em'}
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            <ImageZoom
                                                                                                image={{
                                                                                                    src: "./noimage.gif",
                                                                                                    className: 'img',
                                                                                                    style: {width: '5em'}
                                                                                                }}
                                                                                            />
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            )) :
                                                                            <div
                                                                                className="alert alert-danger"
                                                                                role="alert">
                                                                                No Option!! Question Not valid
                                                                            </div>
                                                                    )
                                                                )
                                                                }
                                                            </td>
                                                            {/*<td>{itemQues.ehq_order ? <span className="badge badge-danger">{itemQues.ehq_order}</span> :  <span className="badge badge-danger">0</span> }</td>*/}
                                                            <td width="250">
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-sm btn-primary`}
                                                                    onClick={() => {
                                                                        this.toggleModalEditOrder(itemQues.question_id, itemQues.ehq_order);
                                                                    }}
                                                                >
                                                                    Pindah Soal
                                                                </button>
                                                                {" "}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm"
                                                                    onClick={() => {
                                                                        this.toggleModalEdit(itemQues.question_id);
                                                                        this.setState({question_id: itemQues.question_id});

                                                                    }}>
                                                                    Edit
                                                                </button>
                                                                {" "}
                                                                {/* <button
                                                                    onClick={() => this.toggleModal(itemQues.question_id)}
                                                                    className="btn btn-danger btn-sm"
                                                                >
                                                                    Hapus
                                                                </button> */}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/*<Paging*/}
                                {/*    handlePageClick={this.handlePageClick.bind(this)}*/}
                                {/*    pageCount={this.state.pageCount}*/}
                                {/*    currentPage={this.state.currentPage}*/}
                                {/*/>*/}
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/Soal.js